// @flow
import { FormattedMessage } from 'react-intl';
import { getMessagesUrl } from '../../../utils/urls';
import { getUnreadInboxCount } from '../../../redux/modules/conversationFolders';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const MessagesNotification = () => {
    const unreadCount = useSelector(getUnreadInboxCount);

    const unreadCountBadge = unreadCount > 99 ? '99+' : unreadCount;

    return (
        <StyledLink key="messages" route to={getMessagesUrl()}>
            <FormattedMessage id="messages" />
            {unreadCount > 0 && <StyledNumber>{unreadCountBadge}</StyledNumber>}
        </StyledLink>
    );
};

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
`;

const StyledNumber = styled.div`
    background-color: ${({ theme }) => theme.colors.red100};
    border-radius: 13px;
    color: ${({ theme }) => theme.colors.white};
    font-size: 13px;
    padding: 2px 5px;
    text-align: center;
    line-height: 13px;
    letter-spacing: 0;
    height: 17px;
    margin-left: 5px;
    float: right;
`;

export default MessagesNotification;
